/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Example_Item51Inputs */

const ja_playdata_eventreport_example_item51 = /** @type {(inputs: Playdata_Eventreport_Example_Item51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャンネル別の累計視聴時間`)
};

const en_playdata_eventreport_example_item51 = /** @type {(inputs: Playdata_Eventreport_Example_Item51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumulative viewing time by channel`)
};

/**
* | output |
* | --- |
* | "Cumulative viewing time by channel" |
*
* @param {Playdata_Eventreport_Example_Item51Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_example_item51 = /** @type {((inputs?: Playdata_Eventreport_Example_Item51Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Example_Item51Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_example_item51(inputs)
	return en_playdata_eventreport_example_item51(inputs)
});
export { playdata_eventreport_example_item51 as "playdata_eventReport_example_item5" }